import React, { useEffect, useRef, useState } from 'react'
import UseScrollReveal from '../Components/Common/UseScrollReveal '
import { getImages } from '../Components/const';
import { Link } from 'react-router-dom';
import SeoMeta from '../Components/Common/SeoMeta';
const tabsItem = [
    { to: "Mens", name: "Mens", content: <p>This is the content for Mens.</p> },
    { to: "Womens", name: "Womens", content: <p>This is the content for Womens.</p> },
    { to: "Kids", name: "Kids", content: <p>This is the content for Kids.</p> },
    { to: "Hats", name: "Hats", content: <p>This is Hats content.</p> },
    { to: "Accesories", name: "Accesories", content: <p>This is Accesories content.</p> },
    { to: "Lifestyle", name: "LIFESTYLE", content: <p>This is LIFESTYLE content.</p> },
];
const boutiqueData = {
    Mens: [
        {
            image: 'pic1.jpg',
            title: 'New Era McLaren Racing Essential Cuff Beanie Hat',
            price: '$29.99',
        },
        {
            image: 'pic2.jpg',
            title: 'McLaren Formula 1 Team Speedmark Keyring',
            price: '$19.99',
        },
        // Add more Mens items...
    ],
    Womens: [
        {
            image: 'pic3.jpg',
            title: 'Official McLaren Formula 1 2025 Team Water Bottle 750ml',
            price: '$24.99',
        },
        // Add more Womens items...
    ],
    Kids: [
        {
            image: 'pic4.jpg',
            title: 'New Era x McLaren Flawless 9Forty Cap - Anthracite',
            price: '$39.99',
        },
        // Add more Kids items...
    ],
    Hats: [
        {
            image: 'pic5.jpg',
            title: 'Official McLaren Formula 1 Team Bottle Opener Keyring',
            price: '$19.99',
        },
        // Add more Hats items...
    ],
    Accesories: [
        {
            image: 'pic6.jpg',
            title: 'McLaren Formula 1 Team Travel Mug',
            price: '$24.99',
        },
        // Add more Accessories items...
    ],
    Lifestyle: [
        {
            image: 'pic7.jpg',
            title: 'K-Swiss x McLaren Mens Slide Sandals',
            price: '$89.99',
        },
        {
            image: 'pic8.jpg',
            title: 'McLaren Unisex Short Sleeve T-Shirt',
            price: '$59.99',
        },
        // Add more Tumi x Mclaren items...
    ],
};
const Boutique = () => {
    UseScrollReveal();
    const activeRef = useRef();
    const none = useRef();
    const [selected, setSelected] = useState("Mens");
    const [offset, setOffset] = useState(0);
    const [width, setWidth] = useState(0);
    useEffect(() => {
        const activeElement = activeRef.current;
        setOffset(activeElement.offsetLeft);
        setWidth(activeElement.clientWidth);
    }, [selected, activeRef]);

    return (
        <>
            <SeoMeta
                title="McLaren Merchandise & Gifts | Official McLaren Orlando Shop"
                description="Shop official McLaren merchandise, apparel, accessories, and gifts at McLaren Orlando. Explore premium products inspired by the McLaren lifestyle."
                keywords=""
                ogTitle="McLaren Merchandise & Gifts | Official McLaren Orlando Shop"
                ogDescription="Shop official McLaren merchandise, apparel, accessories, and gifts at McLaren Orlando. Explore premium products inspired by the McLaren lifestyle."
            />
            <section className='boutique-wrap'>
                <div className='container'>
                    <h4 className='xs-title text-uppercase font-1-1em fw-500 text-orange wow reveal fadeIn'>Get the LATEST gear</h4>
                    <h1 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>Boutique</h1>

                    <div className='boutique-tabs'>
                        <div className='position-relative'>
                            <div className='mob-scroll-y'>
                                <div width={width} offset={offset} className='active-border'
                                    style={{
                                        width: `${width}px`,
                                        transform: `translateX(${offset}px)`,
                                    }}
                                />
                                <ul className='boutique-list'>
                                    {tabsItem.map(item => {
                                        return (
                                            <li
                                                key={item.to}
                                                ref={selected === item.to ? activeRef : none}
                                                className={selected === item.to ? "is-active" : ""}
                                                onClick={() => setSelected(item.to)}
                                            >
                                                {item.name}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="tab-content mt-4">
                            <div className='row g-3'>
                                {boutiqueData[selected]?.map((product, index) => (
                                    <div className='col-lg-3 col-md-4 col-sm-6' key={index}>
                                        <div className='product-box'>
                                            <div className='product-image'>
                                                <Link to="/product-details"><img src={getImages(product.image)} alt='product' /></Link>
                                            </div>
                                            <div className='product-content'>
                                                <h2 className='product-title'>{product.title}</h2>
                                                <div className='product-price mt-2'>{product.price}</div>
                                                <div className='text-center mt-3'>
                                                    <Link to="/product-details" className='product-btn'>Quick View</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Boutique